// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"pieChart_checkboxContainer__q+gKR"};